import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import DropdownOption from "components/Common/DropdownOption";
import DropdownTokenOption from "components/Common/DropdownTokenOption";
import { useFormik } from "formik";
import { CAMPAIGN_TYPE, CAMPAIGN_TYPE_OPTIONS, DECIMALS_SOL, FEE_TIER_OPTIONS, FUNDING_INFO_TYPE_LABEL } from "helpers/constans";
import { customToFixed, formatScientificNumber, toFixedTrunc } from "helpers/format";
import CountdownCircle from "pages/Token/CountdownCircle";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Col, Input, Label, Row, Spinner } from "reactstrap";
import { getCampaign, getAssetCampaign, postCampaign, putCampaign, getListExistedPool, getListAvailableFeeTier } from "store/campaign/thunk";
import { getQuoteToken } from "store/thunks";
import * as Yup from "yup";

export interface Props {
  isOpen?: boolean;
  detail?: any | null;
  idCampaign?: string | number | null;
  listTokenA: any,
  listTokenB: any,
  onClose?: () => void;
  triggerRefresh?: (type?: string) => void;
}

const formatPositionTokenInPool = (poolInfo: any) => {
  const _poolInfo = structuredClone(poolInfo);
  if (_poolInfo?.tokenA !== _poolInfo?.tokens?.[0]?.tokenAddress) {
    return ({
      ..._poolInfo,
      tokens: (_poolInfo?.tokens).reverse()
    });
  }
  return _poolInfo;
};

const CampaignConfiguration = ({ isOpen = false, idCampaign = null, listTokenA, listTokenB, onClose, triggerRefresh }: Props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingDetail, setIsLoadingDetail] = useState<boolean>(false);


  const [listExistedPool, setListExistedPool] = useState<any[]>([]);

  const [listAvailableFeeTiers, setListAvailableFeeTiers] = useState<any[]>(FEE_TIER_OPTIONS);

  const CAMPAIGN_TYPE_OPTIONS_LANG = CAMPAIGN_TYPE_OPTIONS.map((item: any) => ({
    label: t(item.label),
    value: item.value
  }));

  const LIST_TOKEN_A: any = [...(listTokenA || []), ...(listTokenB || [])];
  const LIST_TOKEN_B: any = [...(listTokenB || []), ...(listTokenA || [])];

  const onCloseClick = () => {
    onClose && onClose();
    formik.resetForm();
  };

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);
      const tokenA = values?.tokenInfo?.tokenA;
      const tokenB = values?.tokenInfo?.tokenB;
      const decimalsA = tokenA?.data?.decimals;
      const decimalsB = tokenB?.data?.decimals;
      const tokenMain = values?.tokenInfo?.tokenIn ? values?.tokenInfo?.tokenIn : tokenB?.data;
      const decimalsMain = tokenMain?.decimals || 0;
      const inputTokenMain = tokenMain?.value || tokenB?.value;
      const campaignType = Number(values?.campaignType?.value || CAMPAIGN_TYPE_OPTIONS_LANG[0]?.value);
      const data = {
        type: campaignType,
        ...(campaignType === Number(CAMPAIGN_TYPE.WITH_EXISTED_POOL) ? { targetPool: values?.existedPool?.value || '' } : {}),
        mainPositionConfig: idCampaign ? {} : {
          tokenMintA: tokenA?.value || '',
          tokenMintB: tokenB?.value || '',
          decimalsA: Number(decimalsA),
          decimalsB: Number(decimalsB),
          tokenProgramA: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
          tokenProgramB: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
          initialPrice: Number(values?.tokenInfo?.initialPrice || 0),
          rangeLower: Number(values?.tokenInfo?.rangeLower || 0),
          rangeUpper: Number(values?.tokenInfo?.rangeUpper || 0),
          amountIn: Number(Number(Number(values?.tokenInfo?.amountIn || 0).toFixed(Number(decimalsMain))) * Math.pow(10, Number(decimalsMain))),
          inputTokenMint: inputTokenMain || '',
          slippage: Number(values?.tokenInfo?.slippage || 0),
          tickSpacing: Number(values?.tokenInfo?.tickSpacing || 0),
        },
        openPositionConfig: {
          upperEdgePercentage: Number(values?.openPositionConfig?.upperEdgePercentage || 0),
          lowerEdgePercentage: Number(values?.openPositionConfig?.lowerEdgePercentage || 0),
          newRangePositionPercentage: Number(values?.openPositionConfig?.newRangePositionPercentage || 0),
          amountIn: Number(Number(Number(values?.openPositionConfig?.amountIn || 0).toFixed(Number(decimalsMain))) * Math.pow(10, Number(decimalsMain))),
        },
        closePositionConfig: {
          profitPercentage: Number(values?.closePositionConfig?.profitPercentage || 0),
          stopLossPercentage: Number(values?.closePositionConfig?.stopLossPercentage || 0),
          totalWallet: Number(values?.closePositionConfig?.totalWallet || 0),
          totalAmountBase: Number(values?.closePositionConfig?.totalAmountBase || 0) * Math.pow(10, Number(decimalsMain)),
        },
        tradeConfig: {
          totalWallet: Number(values?.tradeConfig?.totalWallet || 0),

          mainPositionVolRangeMin: Number(Number(Number(values?.tradeConfig?.mainPositionVolRangeMin || 0).toFixed(Number(decimalsMain))) * Math.pow(10, Number(decimalsMain))),
          mainPositionVolRangeMax: Number(Number(Number(values?.tradeConfig?.mainPositionVolRangeMax || 0).toFixed(Number(decimalsMain))) * Math.pow(10, Number(decimalsMain))),

          intervalMin: Number(values?.tradeConfig?.intervalMin || 0),
          intervalMax: Number(values?.tradeConfig?.intervalMax || 0),

          upperPositionBuyDecrease: Number(values?.tradeConfig?.upperPositionBuyDecrease || 0),
          upperPositionSellIncrease: Number(values?.tradeConfig?.upperPositionSellIncrease || 0),
          lowerPositionBuyIncrease: Number(values?.tradeConfig?.lowerPositionBuyIncrease || 0),
        },
        listFundingInfo: (values?.listFundingInfo || []).map((item: any) => ({
          types: Number(item?.types),
          amountA: Number(Number(item?.amountA || 0).toFixed(Number(decimalsA))) * Math.pow(10, Number(decimalsA)),
          amountB: Number(Number(item?.amountB || 0).toFixed(Number(decimalsB))) * Math.pow(10, Number(decimalsB)),
          amountNative: Number(Number(item?.amountNative || 0).toFixed(Number(DECIMALS_SOL))) * Math.pow(10, Number(DECIMALS_SOL)),
        })),
        boostingConfig: {
          status: Boolean(values?.boostingConfig?.status || false),
          buyIncreasePercentage: Number(values?.boostingConfig?.buyIncreasePercentage || 0),
          sellDecreasePercentage: Number(values?.boostingConfig?.sellDecreasePercentage || 0),
          probability: Number(values?.boostingConfig?.probability || 0),
        },
      };
      const response: any = idCampaign ? await putCampaign(idCampaign, data) : await postCampaign(data);
      setIsLoading(false);
      if (response?.data) {
        toast(t("The process has been completed."), CONFIG_OPTION_TOAST_NORMAL);
        triggerRefresh && triggerRefresh();
      } else {
        toast(`${response || "Error - Please try again!"}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading(false);
      toast(`${error?.message || "Error - Please try again!"}`, CONFIG_OPTION_TOAST_ERROR);
    }
  };

  const validationSchema = Yup.object({
    campaignType: Yup.object().shape({
      value: Yup.string()
    }).nullable(),
    existedPool: Yup.object().shape({
      value: Yup.string(),
    }).when('$campaignType', ([campaignType]: any, schema: any) => {
      return String(campaignType?.value) === String(CAMPAIGN_TYPE.WITH_EXISTED_POOL) ? schema.required(t('Required')) : schema.nullable();
    }),
    currentPrice: Yup.number().nullable(),
    boostingConfig: Yup.object({
      status: Yup.boolean().required(t("Required")),
      buyIncreasePercentage: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      sellDecreasePercentage: Yup.number().min(0, t("Must be positive")).max(100, t("Must be less than or equal to 100")).required(t("Required")),
      probability: Yup.number().min(0, t("Must be positive")).max(100, t("Must be less than or equal to 100")).required(t("Required")),
    }),
    tokenInfo: Yup.object({
      tokenA: Yup.object().shape({
        // label: Yup.string().nullable(),
        value: Yup.string(),
      }).required(`${t("This is required")}`),
      tokenB: Yup.object().shape({
        // label: Yup.string().nullable(),
        value: Yup.string(),
      }).required(`${t("This is required")}`),
      slippage: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      tickSpacing: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      initialPrice: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      amountIn: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      tokenIn: Yup.object().shape({
        value: Yup.string(),
      }).nullable(),
      rangeLower: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      rangeUpper: Yup.number().min(0, t("Must be positive")).required(t("Required")),

      rangeLowerPercent: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      rangeUpperPercent: Yup.number().min(0, t("Must be positive")).required(t("Required")),
    }),
    openPositionConfig: Yup.object({
      upperEdgePercentage: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      lowerEdgePercentage: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      newRangePositionPercentage: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      amountIn: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      tokenIn: Yup.object().shape({
        value: Yup.string(),
      }).nullable(),
    }),
    closePositionConfig: Yup.object({
      profitPercentage: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      stopLossPercentage: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      totalWallet: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      totalAmountBase: Yup.number().min(0, t("Must be positive")).required(t("Required")),
    }),
    tradeConfig: Yup.object({
      totalWallet: Yup.number().min(1, t("Must be at least 1")).required(t("Required")),
      mainPositionVolRangeMin: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      mainPositionVolRangeMax: Yup.number()
        .required(t("Required"))
        .when("mainPositionVolRangeMin", (min: any, schema: any) =>
          schema.min(min, t("Max volume must be greater than or equal to min volume"))
        ),
      tokenMain: Yup.object().shape({
        value: Yup.string(),
      }).nullable(),
      intervalMin: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      intervalMax: Yup.number()
        .required(t("Required"))
        .when("intervalMin", (min: any, schema: any) =>
          schema.min(min, t("Max interval must be greater than or equal to min interval"))
        ),
      upperPositionBuyDecrease: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      upperPositionSellIncrease: Yup.number().min(0, t("Must be positive")).required(t("Required")),
      lowerPositionBuyIncrease: Yup.number().min(0, t("Must be positive")).required(t("Required")),
    }),
    listFundingInfo: Yup.array()
      .of(
        Yup.object({
          types: Yup.number().nullable(), //.oneOf([1, 2, 3], t("Must be 1 or 2 or 3")).required(t("Required")),
          amountA: Yup.number().min(0, t("Must be positive")).required(t("Required")),
          amountB: Yup.number().min(0, t("Must be positive")).required(t("Required")),
          amountNative: Yup.number().min(0, t("Must be positive")).required(t("Required")),
        })
      )
      .min(1, t("At least one funding info is required"))
      .required(t("Required")),
    status: Yup.string().required(t("Required")),
    assetWallets: Yup.array().of(Yup.object({
      balanceA: Yup.number(),
      balanceB: Yup.number(),
      balanceNative: Yup.number(),
      wallet: Yup.string(),
    })).nullable(),
  });

  const formik = useFormik({
    initialValues: {
      campaignType: CAMPAIGN_TYPE_OPTIONS_LANG?.[0],
      existedPool: null,
      currentPrice: 0,
      boostingConfig: {
        status: false,
        buyIncreasePercentage: 0,
        sellDecreasePercentage: 0,
        probability: 0,
      },
      tokenInfo: {
        tokenA: LIST_TOKEN_A?.[0] as any || null,
        tokenB: LIST_TOKEN_B?.[0] as any || null,
        slippage: 1,
        tickSpacing: FEE_TIER_OPTIONS?.[6]?.value,
        initialPrice: "",
        amountIn: "",
        tokenIn: null,
        rangeLower: "",
        rangeUpper: "",
        rangeLowerPercent: 10,
        rangeUpperPercent: 10,
      },
      openPositionConfig: {
        upperEdgePercentage: "",
        lowerEdgePercentage: "",
        newRangePositionPercentage: "",
        amountIn: "",
        tokenIn: null,
      },
      closePositionConfig: {
        profitPercentage: "",
        stopLossPercentage: "",
        totalWallet: "",
        totalAmountBase: "",
      },
      tradeConfig: {
        totalWallet: "1",
        mainPositionVolRangeMin: "",
        mainPositionVolRangeMax: "",
        tokenMain: null,
        intervalMin: "",
        intervalMax: "",
        upperPositionBuyDecrease: "",
        upperPositionSellIncrease: "",
        lowerPositionBuyIncrease: "",
      },
      listFundingInfo: [
        {
          types: 1,
          amountA: "",
          amountB: "",
          amountNative: "",
        },
        {
          types: 2,
          amountA: "",
          amountB: "",
          amountNative: "",
        },
        {
          types: 3,
          amountA: "",
          amountB: "",
          amountNative: "",
        },
      ],
      status: 'ACTIVATED',
      assetWallets: [],
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const onChangeLiquidity = (namePriceRange: string, typeChange: 'MINUS' | 'PLUS') => {
    const initialPriceCurrent = (formik.values?.tokenInfo as any)?.initialPrice;
    const percentCurrent = (formik.values?.tokenInfo as any)?.[`${namePriceRange}Percent`];
    const percent = Number(percentCurrent || 0) + (typeChange === 'MINUS' ? -1 : 1);
    const pricePercent = Number(initialPriceCurrent) * (percent / 100);
    const price = Number(initialPriceCurrent) + (pricePercent * (namePriceRange === 'rangeLower' ? -1 : 1));
    const decimalsB = (formik.values?.tokenInfo as any)?.tokenB?.data?.decimals || 0;
    formik.setFieldValue(`tokenInfo.${namePriceRange}Percent`, percent);
    formik.setFieldValue(`tokenInfo.${namePriceRange}`, price);
  };

  const onChangeInitialPrice = (initialPrice: number | string) => {
    const initialPriceCurrent = Number(initialPrice);
    const rangeLowerPercentCurrent = (formik.values?.tokenInfo as any)?.[`rangeLowerPercent`];
    const rangeUpperPercentCurrent = (formik.values?.tokenInfo as any)?.[`rangeUpperPercent`];
    const rangeLowerPercentPrice = Number(initialPriceCurrent) - (Number(initialPriceCurrent) * (rangeLowerPercentCurrent / 100));
    const rangeUpperPercentPrice = Number(initialPriceCurrent) + (Number(initialPriceCurrent) * (rangeUpperPercentCurrent / 100));
    const decimalsB = (formik.values?.tokenInfo as any)?.tokenB?.data?.decimals || 0;
    formik.setFieldValue(`tokenInfo.rangeLower`, rangeLowerPercentPrice);
    formik.setFieldValue(`tokenInfo.rangeUpper`, rangeUpperPercentPrice);
  };

  const getCampaignDetail = async (id: string | number) => {
    setIsLoadingDetail((_prev) => true);
    const [res1, res2]: any = await Promise.all([getCampaign(id), getAssetCampaign(id)]);
    setIsLoadingDetail((_prev) => false);
    if (res1?.data) {
      const data = res1?.data;
      const asset_wallets = res2?.data;
      const main_position_config = data?.main_position_config;
      const open_position_config = data?.open_position_config;
      const close_position_config = data?.close_position_config;
      const trade_config = data?.trade_config;
      const list_funding_info = data?.list_funding_info;
      const tokenA = LIST_TOKEN_A?.find((item: any) => item?.value === main_position_config?.token_mint_a) || null;
      const tokenB = LIST_TOKEN_B?.find((item: any) => item?.value === main_position_config?.token_mint_b) || null;
      const decimalsA = tokenA?.decimals || 0;
      const decimalsB = tokenB?.decimals || 0;
      const fundingInfo = list_funding_info?.map((item: any) => ({
        types: item?.types,
        amountA: Number(customToFixed(Number(item?.amount_a || 0) / Math.pow(10, Number(decimalsA)), decimalsA)),
        amountB: Number(customToFixed(Number(item?.amount_b || 0) / Math.pow(10, Number(decimalsB)), decimalsB)),
        amountNative: Number(customToFixed(Number(item?.amount_native || 0) / Math.pow(10, Number(DECIMALS_SOL)), DECIMALS_SOL)),
      }));
      const inputTokenMint = LIST_TOKEN_B?.find((item: any) => item?.value === main_position_config?.input_token_mint);
      const inputTokenMintDecimals = inputTokenMint?.decimals || 0;

      const dataForm: any = {
        campaignType: CAMPAIGN_TYPE_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(data?.campaign_type)) || null,
        existedPool: !!data?.target_pool ? {
          label: data?.target_pool || '',
          value: data?.target_pool || '',
        } : null,
        boostingConfig: {
          status: Boolean(data?.boosting_config?.status || false),
          buyIncreasePercentage: Number(data?.boosting_config?.buy_increase_percentage || 0),
          sellDecreasePercentage: Number(data?.boosting_config?.sell_decrease_percentage || 0),
          probability: Number(data?.boosting_config?.probability || 0),
        },
        tokenInfo: {
          tokenA: { ...tokenA, data: { ...tokenA } },
          tokenB: { ...tokenB, data: { ...tokenB } },
          slippage: main_position_config?.slippage,
          tickSpacing: main_position_config?.tick_spacing,
          initialPrice: main_position_config?.initial_price,
          amountIn: customToFixed(Number(main_position_config?.amount_in || 0) / Math.pow(10, Number(inputTokenMintDecimals)), inputTokenMintDecimals),
          tokenIn: inputTokenMint,
          rangeLower: main_position_config?.range_lower,
          rangeUpper: main_position_config?.range_upper,
          rangeLowerPercent: 0,
          rangeUpperPercent: 0,
        },
        openPositionConfig: {
          upperEdgePercentage: open_position_config?.upper_edge_percentage,
          lowerEdgePercentage: open_position_config?.lower_edge_percentage,
          newRangePositionPercentage: open_position_config?.new_range_position_percentage,
          amountIn: customToFixed(Number(open_position_config?.amount_in || 0) / Math.pow(10, Number(inputTokenMintDecimals)), inputTokenMintDecimals),
          tokenIn: inputTokenMint,
        },
        closePositionConfig: {
          profitPercentage: close_position_config?.profit_percentage,
          stopLossPercentage: close_position_config?.stop_loss_percentage,
          totalWallet: close_position_config?.total_wallet,
          totalAmountBase: customToFixed(Number(close_position_config?.total_amount_base || 0) / Math.pow(10, Number(inputTokenMintDecimals)), inputTokenMintDecimals),
        },
        tradeConfig: {
          totalWallet: trade_config?.total_wallet,
          mainPositionVolRangeMin: customToFixed(Number(trade_config?.main_position_vol_range_min || 0) / Math.pow(10, Number(inputTokenMintDecimals)), inputTokenMintDecimals),
          mainPositionVolRangeMax: customToFixed(Number(trade_config?.main_position_vol_range_max || 0) / Math.pow(10, Number(inputTokenMintDecimals)), inputTokenMintDecimals),
          tokenMain: inputTokenMint,
          intervalMin: trade_config?.interval_min,
          intervalMax: trade_config?.interval_max,
          upperPositionBuyDecrease: trade_config?.upper_position_buy_decrease,
          upperPositionSellIncrease: trade_config?.upper_position_sell_increase,
          lowerPositionBuyIncrease: trade_config?.lower_position_buy_increase,
        },
        listFundingInfo: fundingInfo,
        status: data?.status || 'ACTIVATED',
        assetWallets: (asset_wallets || [])?.map((item: any) => ({
          balanceA: Number(customToFixed(Number(item?.balanceA || 0) / Math.pow(10, Number(decimalsA)), decimalsA)),
          balanceB: Number(customToFixed(Number(item?.balanceB || 0) / Math.pow(10, Number(decimalsB)), decimalsB)),
          balanceNative: Number(customToFixed(Number(item?.balanceNative || 0) / Math.pow(10, Number(DECIMALS_SOL)), DECIMALS_SOL)),
          wallet: item?.wallet,
        })),
      };
      formik.setValues(dataForm);
    }
  };

  useEffect(() => {
    if (!!idCampaign) {
      getCampaignDetail(idCampaign);
    }
  }, [idCampaign]);

  useEffect(() => {
    if (!!isOpen && !idCampaign && !!(String(formik.values.campaignType?.value) === String(CAMPAIGN_TYPE.WITH_EXISTED_POOL)) && !!formik.values.tokenInfo.tokenA?.value) {
      const getExistedPools = async () => {
        try {
          const res: any = await getListExistedPool({ mint: formik.values.tokenInfo.tokenA?.value });
          const _data = (res?.data || [])?.map((item: any) => ({
            label: item?.PoolAddress,
            value: `${item?.PoolAddress}`,
            data: {
              tickSpacing: `${item?.TickSpacing}`
            }
          }));
          setListExistedPool(_data);
          if (!!idCampaign) {
            return;
          }
          formik.setFieldValue("existedPool", _data?.[0]);
          formik.setFieldValue("tokenInfo.tickSpacing", FEE_TIER_OPTIONS?.find((item: any) => String(item?.value) === String(_data?.[0]?.data?.tickSpacing))?.value || null);
        } catch (error) {
          console.log("error", error);
        }
      }
      getExistedPools();
    }
  }, [isOpen, idCampaign, String(formik.values.campaignType?.value), String(formik.values.tokenInfo.tokenA?.value)]);

  useEffect(() => {
    if (!!isOpen && !idCampaign && !!([CAMPAIGN_TYPE.WITH_EXISTED_POOL, CAMPAIGN_TYPE.NEW_POOL]?.includes(formik.values.campaignType?.value)) && !!formik.values.tokenInfo.tokenA?.value && !!formik.values.tokenInfo.tokenB?.value) {
      const getAvailableFeeTiers = async () => {
        try {
          const res: any = await getListAvailableFeeTier({ tokenA: formik.values.tokenInfo.tokenA?.value, tokenB: formik.values.tokenInfo.tokenB?.value });
          const _data = (res?.data || {});
          const _dataFeeTiers = FEE_TIER_OPTIONS?.filter((item: any) => !_data?.[Number(item?.value)]);
          setListAvailableFeeTiers(_dataFeeTiers);
          if (!!idCampaign) {
            return;
          }
          formik.setFieldValue("tokenInfo.tickSpacing", _dataFeeTiers[0]?.value);
        } catch (error) {
          console.log("error", error);
        }
      }
      getAvailableFeeTiers();
    }
  }, [isOpen, idCampaign, String(formik.values.campaignType?.value), String(formik.values.tokenInfo.tokenA?.value), String(formik.values.tokenInfo.tokenB?.value)]);


  const [isCountdown, setIsCountdown] = useState(false);

  const getQuote = async (_token_mint: string) => {
    try {
      const res: any = await getQuoteToken({ mint: _token_mint });
      formik.setFieldValue("currentPrice", res?.data || 0);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    try {
      let apiIntervalId: any = null;

      if (!!isOpen && !idCampaign && !!(String(formik.values.campaignType?.value) !== String(CAMPAIGN_TYPE.FIRST_POOL)) && !!formik.values.tokenInfo.tokenA?.value) {
        if (!!apiIntervalId) {
          clearInterval(apiIntervalId);
        }
        getQuote(formik.values.tokenInfo.tokenA?.value);
        apiIntervalId = setInterval(() => {
          setIsCountdown((_prev) => !_prev);
          getQuote(formik.values.tokenInfo.tokenA?.value);
        }, 20000);

        return () => {
          clearInterval(apiIntervalId);
        };
      } else if (!!isOpen && !!(String(formik.values.campaignType?.value) === String(CAMPAIGN_TYPE.FIRST_POOL)) && !!apiIntervalId) {
        clearInterval(apiIntervalId);
      }
    } catch (error) {
      console.log("error", error);
    }
  }, [isOpen, idCampaign, String(formik.values.campaignType?.value), String(formik.values.tokenInfo.tokenA?.value)]);


  const isShowWarningInitialPrice = useMemo(() => {
    if (![String(CAMPAIGN_TYPE.WITH_EXISTED_POOL), String(CAMPAIGN_TYPE.NEW_POOL)]?.includes(String(formik.values.campaignType?.value))) {
      return false;
    }
    return (Number(formik.values.tokenInfo.initialPrice || 0) - Number(formik.values.currentPrice || 0)) / Number(formik.values.currentPrice || 0) > 0.05;
  }, [formik.values.tokenInfo.initialPrice, formik.values.currentPrice, String(formik.values.campaignType?.value)]);

  return (
    <div className="py-2 relative">
      {isLoadingDetail && (
        <div className="position-absolute z-index-1000" style={{ zIndex: 998, top: "0px", right: "0px", bottom: "0px", left: "0px", backgroundColor: "#cdcdcd4a", display: "flex", alignItems: "start", justifyContent: "center" }}>
          <span style={{ transform: "translateY(40dvh)", zIndex: 999 }}><Spinner className="text-primary" /></span>
        </div>
      )}
      <form onSubmit={formik.handleSubmit}>
        {/* Token Info Section */}
        <div style={{ border: "1px dashed var(--vz-primary)", borderRadius: "4px", padding: "10px" }} className="position-relative py-3 pt-4 mb-4">
          <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: "0px", transform: "translateY(-50%)" }}>
            {t("Token Info")}
          </span>
          <Row>
            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Token A")}</Label>
                <DropdownTokenOption
                  isMultiLang
                  name="tokenInfo.tokenA"
                  dataList={LIST_TOKEN_A}
                  initialValue={formik.values.tokenInfo.tokenA}
                  onChangeSelect={(event: any) => formik.setFieldValue("tokenInfo.tokenA", event)}
                  className="dropdown-status-rounded z-hight"
                  classNamePrefix="name-prefix"
                  labelTop=""
                  invalid={!!(formik.touched.tokenInfo?.tokenA && formik.errors.tokenInfo?.tokenA)}
                  disabled={!!idCampaign}
                />
                {formik.touched.tokenInfo?.tokenA && formik.errors.tokenInfo?.tokenA && (
                  <div className="text-danger fs-12">{(formik.errors.tokenInfo as any)?.tokenA}</div>
                )}
              </div>
            </Col>
            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Token B")}</Label>
                <DropdownTokenOption
                  isMultiLang
                  name="tokenInfo.tokenB"
                  dataList={LIST_TOKEN_B}
                  initialValue={formik.values.tokenInfo.tokenB}
                  onChangeSelect={(event: any) => formik.setFieldValue("tokenInfo.tokenB", event)}
                  className="dropdown-status-rounded z-hight"
                  classNamePrefix="name-prefix"
                  labelTop=""
                  invalid={!!(formik.touched.tokenInfo?.tokenB && formik.errors.tokenInfo?.tokenB)}
                  disabled={!!idCampaign}
                />
                {formik.touched.tokenInfo?.tokenB && formik.errors.tokenInfo?.tokenB && (
                  <div className="text-danger fs-12">{(formik.errors.tokenInfo as any)?.tokenB}</div>
                )}
              </div>
            </Col>
            <Col sm={12} md={12}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Campaign Type")}</Label>
                <DropdownOption
                  name="campaignType"
                  dataList={CAMPAIGN_TYPE_OPTIONS_LANG}
                  initialValue={formik.values.campaignType}
                  onChangeSelect={(event: any) => formik.setFieldValue("campaignType", event)}
                  className="dropdown-status-rounded z-hight"
                  classNamePrefix="name-prefix"
                  labelTop=""
                  disabled={!!idCampaign}
                />
                {formik.touched.campaignType && formik.errors.campaignType && (
                  <div className="text-danger fs-12">{(formik.errors.campaignType as any)?.value}</div>
                )}
              </div>
            </Col>
            {String(formik.values.campaignType?.value) === String(CAMPAIGN_TYPE.WITH_EXISTED_POOL) && <Col sm={12} md={12}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Existed Pool")}</Label>
                <DropdownOption
                  isMultiLang
                  name="existedPool"
                  dataList={(idCampaign && String(formik.values.campaignType?.value) === String(CAMPAIGN_TYPE.WITH_EXISTED_POOL)) ? [{ label: (formik.values.existedPool as any)?.label, value: (formik.values.existedPool as any)?.value }] : listExistedPool}
                  initialValue={formik.values.existedPool}
                  onChangeSelect={(event: any) => {
                    formik.setFieldValue("existedPool", event);
                    const _tickSpacing = listAvailableFeeTiers?.find((item: any) => String(item?.value) === String(event?.tickSpacing))?.value || null;
                    formik.setFieldValue("tokenInfo.tickSpacing", _tickSpacing);
                  }}
                  className="dropdown-status-rounded z-hight"
                  classNamePrefix="name-prefix"
                  labelTop=""
                  disabled={!!idCampaign}
                  isHaveMore={true}
                />
                {formik.touched.existedPool && formik.errors.existedPool && (
                  <div className="text-danger fs-12">{formik.errors.existedPool}</div>
                )}
              </div>
            </Col>}
            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Slippage")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="tokenInfo.slippage"
                  value={formik.values.tokenInfo.slippage}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("tokenInfo.slippage", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.tokenInfo?.slippage && formik.errors.tokenInfo?.slippage)}
                  disabled={!!idCampaign}
                />
                {formik.touched.tokenInfo?.slippage && formik.errors.tokenInfo?.slippage && (
                  <div className="text-danger fs-12">{formik.errors.tokenInfo.slippage}</div>
                )}
              </div>
            </Col>

            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Initial Amount")}</Label>
                <div className="position-relative">
                  <Input
                    className="no-icon-invalid"
                    type="text"
                    name="tokenInfo.amountIn"
                    value={formik.values.tokenInfo.amountIn}
                    placeholder="0"
                    onChange={(e) => formik.setFieldValue("tokenInfo.amountIn", e.target.value.replace(/[^0-9.]/g, ""))}
                    onBlur={formik.handleBlur}
                    invalid={!!(formik.touched.tokenInfo?.amountIn && formik.errors.tokenInfo?.amountIn)}
                    disabled={!!idCampaign}
                  />
                  <span className="text-muted position-absolute" style={{ top: '9px', right: '9px' }}>{(formik?.values?.tokenInfo?.tokenIn as any)?.symbol || (formik.values.tokenInfo.tokenB as any)?.data?.symbol || ''}</span>
                </div>
                {formik.touched.tokenInfo?.amountIn && formik.errors.tokenInfo?.amountIn && (
                  <div className="text-danger fs-12">{formik.errors.tokenInfo.amountIn}</div>
                )}
              </div>
            </Col>

            <Col sm={12} md={12}>
              <div className="mb-4">
                <div className="d-flex align-items-center justify-content-between">
                  <Label className="text-primary fs-13 ">
                    {t("Initial Price")}
                  </Label>
                  {[String(CAMPAIGN_TYPE.NEW_POOL), String(CAMPAIGN_TYPE.WITH_EXISTED_POOL)]?.includes(String(formik.values.campaignType?.value)) && <Label className="text-muted fs-13 d-flex align-items-center">
                    <div className="d-flex align-items-center gap-1">
                      <CountdownCircle change={isCountdown} /> {t("Current Price")}: {formatScientificNumber(formik.values.currentPrice, 6, '')} USDC/{(formik.values.tokenInfo.tokenA as any)?.data?.symbol || ''}
                    </div>
                    <div className="d-flex align-items-center text-success cursor-pointer fs-12 ms-2" onClick={() => {
                      const val = Number(formatScientificNumber(formik.values.currentPrice, 6, ''));
                      formik.setFieldValue("tokenInfo.initialPrice", val);
                      onChangeInitialPrice(val || 0);
                    }}>
                      {t('Use this price')}
                    </div>
                  </Label>}
                </div>
                <div className="position-relative">
                  <Input
                    className="no-icon-invalid"
                    type="text"
                    name="tokenInfo.initialPrice"
                    value={formik.values.tokenInfo.initialPrice}
                    placeholder="0"
                    onChange={(e) => {
                      const val = e.target.value.replace(/[^0-9.]/g, "");
                      formik.setFieldValue("tokenInfo.initialPrice", val);
                      onChangeInitialPrice(val || 0);
                    }}
                    onBlur={formik.handleBlur}
                    invalid={!!(formik.touched.tokenInfo?.initialPrice && formik.errors.tokenInfo?.initialPrice)}
                    disabled={!!idCampaign}
                  />
                  <span className="text-muted position-absolute" style={{ top: '9px', right: '9px' }}>{(formik.values.tokenInfo.tokenB as any)?.data?.symbol || ''} {t('per')} {(formik.values.tokenInfo.tokenA as any)?.data?.symbol || ''}</span>
                </div>
                {isShowWarningInitialPrice && <div className="text-warning fs-12">{t("Initial price deviates more than 5% from the estimated market price.")}</div>}
                {formik.touched.tokenInfo?.initialPrice && formik.errors.tokenInfo?.initialPrice && (
                  <div className="text-danger fs-12">{formik.errors.tokenInfo.initialPrice}</div>
                )}

              </div>
            </Col>

            <Col sm={12} md={12}>
              <div className="mb-4">
                <h5 className="mb-2">{t("Initial Price Range")}</h5>
                <Row>
                  <Col xs={6}>
                    <Label className="text-primary fs-13">{t("Min Price")} <span className="text-muted fs-12">({Number(formik.values.tokenInfo.rangeLowerPercent) * -1} %)</span></Label>
                    <div className="input-step full-width">
                      <button type="button" className="minus" onClick={() => onChangeLiquidity('rangeLower', 'MINUS')}>–</button>
                      <Input
                        className="no-icon-invalid product-quantity"
                        type="text"
                        name="tokenInfo.rangeLower"
                        value={formik.values.tokenInfo.rangeLower}
                        placeholder={t("Min")}
                        onChange={(e) => formik.setFieldValue("tokenInfo.rangeLower", e.target.value.replace(/[^0-9.]/g, ""))}
                        onBlur={formik.handleBlur}
                        invalid={!!(formik.touched.tokenInfo?.rangeLower && formik.errors.tokenInfo?.rangeLower)}
                        disabled={!!idCampaign}
                      />
                      <button type="button" className="plus" onClick={() => onChangeLiquidity('rangeLower', 'PLUS')}>+</button>
                    </div>
                    {formik.touched.tokenInfo?.rangeLower && formik.errors.tokenInfo?.rangeLower && (
                      <div className="text-danger fs-12">{formik.errors.tokenInfo.rangeLower}</div>
                    )}
                  </Col>
                  <Col xs={6}>
                    <Label className="text-primary fs-13">{t("Max Price")} <span className="text-muted fs-12">({Number(formik.values.tokenInfo.rangeUpperPercent) > 0 ? '+' : ''}{Number(formik.values.tokenInfo.rangeUpperPercent)} %)</span></Label>
                    <div className="input-step full-width">
                      <button type="button" className="minus" onClick={() => onChangeLiquidity('rangeUpper', 'MINUS')}>–</button>
                      <Input
                        className="no-icon-invalid product-quantity"
                        type="text"
                        name="tokenInfo.rangeUpper"
                        value={formik.values.tokenInfo.rangeUpper}
                        placeholder={t("Max")}
                        onChange={(e) => formik.setFieldValue("tokenInfo.rangeUpper", e.target.value.replace(/[^0-9.]/g, ""))}
                        onBlur={formik.handleBlur}
                        invalid={!!(formik.touched.tokenInfo?.rangeUpper && formik.errors.tokenInfo?.rangeUpper)}
                        disabled={!!idCampaign}
                      />
                      <button type="button" className="plus" onClick={() => onChangeLiquidity('rangeUpper', 'PLUS')}>+</button>
                    </div>
                    {formik.touched.tokenInfo?.rangeUpper && formik.errors.tokenInfo?.rangeUpper && (
                      <div className="text-danger fs-12">{formik.errors.tokenInfo.rangeUpper}</div>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
            <Col sm={12} md={12}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Fee Tier")}</Label>
                <DropdownOption
                  name="tokenInfo.tickSpacing"
                  dataList={listAvailableFeeTiers}
                  initialValue={listAvailableFeeTiers?.find((item: any) => String(item?.value) === String(formik?.values?.tokenInfo?.tickSpacing)) || null}
                  onChangeSelect={(event: any) => {
                    formik.setFieldValue('tokenInfo.tickSpacing', event?.value);
                  }}
                  className="dropdown-status-rounded z-hight"
                  classNamePrefix="name-prefix"
                  disabled={!!(String(formik.values.campaignType?.value) === String(CAMPAIGN_TYPE.WITH_EXISTED_POOL)) || !!idCampaign}
                />
                {formik.touched.tokenInfo?.tickSpacing && formik.errors.tokenInfo?.tickSpacing && (
                  <div className="text-danger fs-12">{formik.errors.tokenInfo.tickSpacing}</div>
                )}
              </div>
            </Col>

          </Row>
        </div>

        {/* Open Position Config Section */}
        <div style={{ border: "1px dashed var(--vz-primary)", borderRadius: "4px", padding: "10px" }} className="position-relative py-3 pt-4 mb-4">
          <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: "0px", transform: "translateY(-50%)" }}>
            {t("Open Position Config")}
          </span>
          <Row>
            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Lower Edge Percentage")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="openPositionConfig.lowerEdgePercentage"
                  value={formik.values.openPositionConfig.lowerEdgePercentage}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("openPositionConfig.lowerEdgePercentage", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.openPositionConfig?.lowerEdgePercentage && formik.errors.openPositionConfig?.lowerEdgePercentage)}
                />
                {formik.touched.openPositionConfig?.lowerEdgePercentage && formik.errors.openPositionConfig?.lowerEdgePercentage && (
                  <div className="text-danger fs-12">{formik.errors.openPositionConfig.lowerEdgePercentage}</div>
                )}
              </div>
            </Col>
            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Upper Edge Percentage")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="openPositionConfig.upperEdgePercentage"
                  value={formik.values.openPositionConfig.upperEdgePercentage}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("openPositionConfig.upperEdgePercentage", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.openPositionConfig?.upperEdgePercentage && formik.errors.openPositionConfig?.upperEdgePercentage)}
                />
                {formik.touched.openPositionConfig?.upperEdgePercentage && formik.errors.openPositionConfig?.upperEdgePercentage && (
                  <div className="text-danger fs-12">{formik.errors.openPositionConfig.upperEdgePercentage}</div>
                )}
              </div>
            </Col>
            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("New Range Position Percentage")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="openPositionConfig.newRangePositionPercentage"
                  value={formik.values.openPositionConfig.newRangePositionPercentage}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("openPositionConfig.newRangePositionPercentage", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.openPositionConfig?.newRangePositionPercentage && formik.errors.openPositionConfig?.newRangePositionPercentage)}
                />
                {formik.touched.openPositionConfig?.newRangePositionPercentage && formik.errors.openPositionConfig?.newRangePositionPercentage && (
                  <div className="text-danger fs-12">{formik.errors.openPositionConfig.newRangePositionPercentage}</div>
                )}
              </div>
            </Col>
            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Amount In")}</Label>
                <div className="position-relative">
                  <Input
                    className="no-icon-invalid"
                    type="text"
                    name="openPositionConfig.amountIn"
                    value={formik.values.openPositionConfig.amountIn}
                    placeholder="0"
                    onChange={(e) => formik.setFieldValue("openPositionConfig.amountIn", e.target.value.replace(/[^0-9.]/g, ""))}
                    onBlur={formik.handleBlur}
                    invalid={!!(formik.touched.openPositionConfig?.amountIn && formik.errors.openPositionConfig?.amountIn)}
                  />
                  <span className="text-muted position-absolute" style={{ top: '9px', right: '9px' }}>{(formik?.values?.openPositionConfig?.tokenIn as any)?.symbol || (formik.values.tokenInfo.tokenB as any)?.data?.symbol || ''}</span>
                </div>
                {formik.touched.openPositionConfig?.amountIn && formik.errors.openPositionConfig?.amountIn && (
                  <div className="text-danger fs-12">{formik.errors.openPositionConfig.amountIn}</div>
                )}
              </div>
            </Col>
          </Row>
        </div>

        {/* Close Position Config Section */}
        <div style={{ border: "1px dashed var(--vz-primary)", borderRadius: "4px", padding: "10px" }} className="position-relative py-3 pt-4 mb-4">
          <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: "0px", transform: "translateY(-50%)" }}>
            {t("Close Position Config")}
          </span>
          <Row>
            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Target Profit")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="closePositionConfig.profitPercentage"
                  value={formik.values.closePositionConfig.profitPercentage}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("closePositionConfig.profitPercentage", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.closePositionConfig?.profitPercentage && formik.errors.closePositionConfig?.profitPercentage)}
                />
                {formik.touched.closePositionConfig?.profitPercentage && formik.errors.closePositionConfig?.profitPercentage && (
                  <div className="text-danger fs-12">{formik.errors.closePositionConfig.profitPercentage}</div>
                )}
              </div>
            </Col>

            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Stop Loss")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="closePositionConfig.stopLossPercentage"
                  value={formik.values.closePositionConfig.stopLossPercentage}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("closePositionConfig.stopLossPercentage", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.closePositionConfig?.stopLossPercentage && formik.errors.closePositionConfig?.stopLossPercentage)}
                />
                {formik.touched.closePositionConfig?.stopLossPercentage && formik.errors.closePositionConfig?.stopLossPercentage && (
                  <div className="text-danger fs-12">{formik.errors.closePositionConfig.stopLossPercentage}</div>
                )}
              </div>
            </Col>

            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Total Wallet")}</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="closePositionConfig.totalWallet"
                  value={formik.values.closePositionConfig.totalWallet}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("closePositionConfig.totalWallet", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.closePositionConfig?.totalWallet && formik.errors.closePositionConfig?.totalWallet)}
                />
                {formik.touched.closePositionConfig?.totalWallet && formik.errors.closePositionConfig?.totalWallet && (
                  <div className="text-danger fs-12">{formik.errors.closePositionConfig.totalWallet}</div>
                )}
              </div>
            </Col>

            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Total Amount Base")}</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="closePositionConfig.totalAmountBase"
                  value={formik.values.closePositionConfig.totalAmountBase}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("closePositionConfig.totalAmountBase", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.closePositionConfig?.totalAmountBase && formik.errors.closePositionConfig?.totalAmountBase)}
                />
                {formik.touched.closePositionConfig?.totalAmountBase && formik.errors.closePositionConfig?.totalAmountBase && (
                  <div className="text-danger fs-12">{formik.errors.closePositionConfig.totalAmountBase}</div>
                )}
              </div>
            </Col>

          </Row>
        </div>

        {/* Boosting Config Section */}
        <div style={{ border: "1px dashed var(--vz-primary)", borderRadius: "4px", padding: "10px" }} className="position-relative py-3 pt-4 mb-4">
          <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: "0px", transform: "translateY(-50%)" }}>
            {t("Boosting Config")}
          </span>
          <Row>
            <Col sm={12} md={12} className="align-self-end">
              <div className="mb-4 d-flex align-items-center gap-2">
                <div className="form-check form-switch mb-0">
                  <Input className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="is_booting_config"
                    name="is_booting_config"
                    checked={!!formik.values.boostingConfig.status}
                    onChange={(event: any) => formik.setFieldValue('boostingConfig.status', Boolean(event?.target.checked))}
                  />
                  <label className="form-check-label text-primary fs-13" htmlFor="is_booting_config">{t("Induce Price Increase")}</label>
                </div>
                {formik.touched.boostingConfig?.status && formik.errors.boostingConfig?.status && (
                  <div className="text-danger fs-12">{formik.errors.boostingConfig.status}</div>
                )}
              </div>
            </Col>

            <Col sm={6} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Buy Increase Percentage")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="boostingConfig.buyIncreasePercentage"
                  value={formik.values.boostingConfig.buyIncreasePercentage}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("boostingConfig.buyIncreasePercentage", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.boostingConfig?.buyIncreasePercentage && formik.errors.boostingConfig?.buyIncreasePercentage)}
                />
              </div>
            </Col>
            <Col sm={6} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Sell Decrease Percentage")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="boostingConfig.sellDecreasePercentage"
                  value={formik.values.boostingConfig.sellDecreasePercentage}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("boostingConfig.sellDecreasePercentage", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.boostingConfig?.sellDecreasePercentage && formik.errors.boostingConfig?.sellDecreasePercentage)}
                />
              </div>
            </Col>
            <Col sm={12} md={12}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Probability")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="boostingConfig.probability"
                  value={formik.values.boostingConfig.probability}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("boostingConfig.probability", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.boostingConfig?.probability && formik.errors.boostingConfig?.probability)}
                />
              </div>
            </Col>
          </Row>
        </div>

        {/* Trade Config Section */}
        <div style={{ border: "1px dashed var(--vz-primary)", borderRadius: "4px", padding: "10px" }} className="position-relative py-3 pt-4 mb-4">
          <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: "0px", transform: "translateY(-50%)" }}>
            {t("Trade Config")}
          </span>
          <Row>
            <Col sm={6} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Total Wallet")}</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="tradeConfig.totalWallet"
                  value={formik.values.tradeConfig.totalWallet}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("tradeConfig.totalWallet", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.tradeConfig?.totalWallet && formik.errors.tradeConfig?.totalWallet)}
                />
                {formik.touched.tradeConfig?.totalWallet && formik.errors.tradeConfig?.totalWallet && (
                  <div className="text-danger fs-12">{formik.errors.tradeConfig.totalWallet}</div>
                )}
              </div>
            </Col>
            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Upper Position Sell Increase")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="tradeConfig.upperPositionSellIncrease"
                  value={formik.values.tradeConfig.upperPositionSellIncrease}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("tradeConfig.upperPositionSellIncrease", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.tradeConfig?.upperPositionSellIncrease && formik.errors.tradeConfig?.upperPositionSellIncrease)}
                />
                {formik.touched.tradeConfig?.upperPositionSellIncrease && formik.errors.tradeConfig?.upperPositionSellIncrease && (
                  <div className="text-danger fs-12">{formik.errors.tradeConfig.upperPositionSellIncrease}</div>
                )}
              </div>
            </Col>
            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Lower Position Buy Increase")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="tradeConfig.lowerPositionBuyIncrease"
                  value={formik.values.tradeConfig.lowerPositionBuyIncrease}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("tradeConfig.lowerPositionBuyIncrease", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.tradeConfig?.lowerPositionBuyIncrease && formik.errors.tradeConfig?.lowerPositionBuyIncrease)}
                />
                {formik.touched.tradeConfig?.lowerPositionBuyIncrease && formik.errors.tradeConfig?.lowerPositionBuyIncrease && (
                  <div className="text-danger fs-12">{formik.errors.tradeConfig.lowerPositionBuyIncrease}</div>
                )}
              </div>
            </Col>
            <Col sm={12} md={6}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Upper Position Buy Decrease")}(%)</Label>
                <Input
                  className="no-icon-invalid"
                  type="text"
                  name="tradeConfig.upperPositionBuyDecrease"
                  value={formik.values.tradeConfig.upperPositionBuyDecrease}
                  placeholder="0"
                  onChange={(e) => formik.setFieldValue("tradeConfig.upperPositionBuyDecrease", e.target.value.replace(/[^0-9.]/g, ""))}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.tradeConfig?.upperPositionBuyDecrease && formik.errors.tradeConfig?.upperPositionBuyDecrease)}
                />
                {formik.touched.tradeConfig?.upperPositionBuyDecrease && formik.errors.tradeConfig?.upperPositionBuyDecrease && (
                  <div className="text-danger fs-12">{formik.errors.tradeConfig.upperPositionBuyDecrease}</div>
                )}
              </div>
            </Col>

            <Col sm={12} md={12}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Main Position Volume Range")}</Label>
                <Row>
                  <Col xs={6}>
                    <div className="position-relative">
                      <Input
                        className="no-icon-invalid"
                        type="text"
                        name="tradeConfig.mainPositionVolRangeMin"
                        value={formik.values.tradeConfig.mainPositionVolRangeMin}
                        placeholder={t("Min")}
                        onChange={(e) => formik.setFieldValue("tradeConfig.mainPositionVolRangeMin", e.target.value.replace(/[^0-9.]/g, ""))}
                        onBlur={formik.handleBlur}
                        invalid={!!(formik.touched.tradeConfig?.mainPositionVolRangeMin && formik.errors.tradeConfig?.mainPositionVolRangeMin)}
                      />
                      <span className="text-muted position-absolute" style={{ top: '9px', right: '9px' }}>{(formik?.values?.tradeConfig?.tokenMain as any)?.symbol || (formik.values.tokenInfo.tokenB as any)?.data?.symbol || ''}</span>
                    </div>
                    {formik.touched.tradeConfig?.mainPositionVolRangeMin && formik.errors.tradeConfig?.mainPositionVolRangeMin && (
                      <div className="text-danger fs-12">{formik.errors.tradeConfig.mainPositionVolRangeMin}</div>
                    )}
                  </Col>
                  <Col xs={6}>
                    <div className="position-relative">
                      <Input
                        className="no-icon-invalid"
                        type="text"
                        name="tradeConfig.mainPositionVolRangeMax"
                        value={formik.values.tradeConfig.mainPositionVolRangeMax}
                        placeholder={t("Max")}
                        onChange={(e) => formik.setFieldValue("tradeConfig.mainPositionVolRangeMax", e.target.value.replace(/[^0-9.]/g, ""))}
                        onBlur={formik.handleBlur}
                        invalid={!!(formik.touched.tradeConfig?.mainPositionVolRangeMax && formik.errors.tradeConfig?.mainPositionVolRangeMax)}
                      />
                      <span className="text-muted position-absolute" style={{ top: '9px', right: '9px' }}>{(formik?.values?.tradeConfig?.tokenMain as any)?.symbol || (formik.values.tokenInfo.tokenB as any)?.data?.symbol || ''}</span>
                    </div>
                    {formik.touched.tradeConfig?.mainPositionVolRangeMax && formik.errors.tradeConfig?.mainPositionVolRangeMax && (
                      <div className="text-danger fs-12">{formik.errors.tradeConfig.mainPositionVolRangeMax}</div>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
            <Col sm={12} md={12}>
              <div className="mb-4">
                <Label className="text-primary fs-13">{t("Time Interval Range")}({t('seconds')})</Label>
                <Row>
                  <Col xs={6}>
                    <Input
                      className="no-icon-invalid"
                      type="text"
                      name="tradeConfig.intervalMin"
                      value={formik.values.tradeConfig.intervalMin}
                      placeholder={t("Min")}
                      onChange={(e) => formik.setFieldValue("tradeConfig.intervalMin", e.target.value.replace(/[^0-9.]/g, ""))}
                      onBlur={formik.handleBlur}
                      invalid={!!(formik.touched.tradeConfig?.intervalMin && formik.errors.tradeConfig?.intervalMin)}
                    />
                    {formik.touched.tradeConfig?.intervalMin && formik.errors.tradeConfig?.intervalMin && (
                      <div className="text-danger fs-12">{formik.errors.tradeConfig.intervalMin}</div>
                    )}
                  </Col>
                  <Col xs={6}>
                    <Input
                      className="no-icon-invalid"
                      type="text"
                      name="tradeConfig.intervalMax"
                      value={formik.values.tradeConfig.intervalMax}
                      placeholder={t("Max")}
                      onChange={(e) => formik.setFieldValue("tradeConfig.intervalMax", e.target.value.replace(/[^0-9.]/g, ""))}
                      onBlur={formik.handleBlur}
                      invalid={!!(formik.touched.tradeConfig?.intervalMax && formik.errors.tradeConfig?.intervalMax)}
                    />
                    {formik.touched.tradeConfig?.intervalMax && formik.errors.tradeConfig?.intervalMax && (
                      <div className="text-danger fs-12">{formik.errors.tradeConfig.intervalMax}</div>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>

        {/* Asset Wallets Section */}
        {formik.values.assetWallets?.length > 0 && (<div style={{ border: "1px dashed var(--vz-primary)", borderRadius: "4px", padding: "10px" }} className="position-relative py-3 pt-4 mb-4">
          <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: "0px", transform: "translateY(-50%)" }}>
            {isLoadingDetail && (<Spinner size="sm" />)}
            {t("Wallets")}
          </span>
          {formik.values.assetWallets.map((wallet: any, index: number) => (
            <div key={index} className="mb-2">
              <h5 className="mb-2">{index + 1}.{t(`${t("Wallet")}`)}: <span className="text-muted fs-13">{wallet?.wallet}</span></h5>
              <Row>
                <Col sm={12} md={12}>
                  <div className="ms-4 ps-2">
                    <Label className="fs-13">{t("Balance A")}</Label>: <span className="text-muted fs-13"> <span className="text-primary">{wallet.balanceA}</span> {(formik.values.tokenInfo.tokenA as any)?.data?.symbol || ''}</span>
                  </div>
                </Col>
                <Col sm={12} md={12}>
                  <div className="ms-4 ps-2">
                    <Label className="fs-13">{t("Balance B")}</Label>: <span className="text-muted fs-13"> <span className="text-primary">{wallet.balanceB}</span> {(formik.values.tokenInfo.tokenB as any)?.data?.symbol || ''}</span>
                  </div>
                </Col>
                <Col sm={12} md={12}>
                  <div className="ms-4 ps-2">
                    <Label className="fs-13">{t("Balance Native")}</Label>: <span className="text-muted fs-13"> <span className="text-primary">{wallet.balanceNative}</span> SOL</span>
                  </div>
                </Col>
              </Row>
            </div>
          ))}
        </div>)}

        {/* Funding Info Section */}
        <div style={{ border: "1px dashed var(--vz-primary)", borderRadius: "4px", padding: "10px" }} className="position-relative py-3 pt-4 mb-4">
          <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: "0px", transform: "translateY(-50%)" }}>
            {t("Funding Info")}
          </span>
          {formik.values.listFundingInfo.map((funding: any, index: number) => (
            <div key={index} className="mb-4">
              <h5 className="mb-2">{t(`${t("Funding Info")} (${t(FUNDING_INFO_TYPE_LABEL[`${funding?.types}`])})`)}</h5>
              <Row>
                <Col sm={12} md={6}>
                  <div className="mb-4">
                    <Label className="text-primary fs-13">{t("Amount A")}</Label>
                    <div className="position-relative">
                      <Input
                        className="no-icon-invalid"
                        type="text"
                        name={`listFundingInfo[${index}].amountA`}
                        value={funding.amountA}
                        placeholder="0"
                        onChange={(e) => formik.setFieldValue(`listFundingInfo[${index}].amountA`, e.target.value.replace(/[^0-9.]/g, ""))}
                        onBlur={formik.handleBlur}
                        invalid={!!(formik.touched.listFundingInfo?.[index]?.amountA && (formik.errors.listFundingInfo as any)?.[index]?.amountA)}
                      />
                      <span className="text-muted position-absolute" style={{ top: '9px', right: '9px' }}>{(formik.values.tokenInfo.tokenA as any)?.data?.symbol || ''}</span>
                    </div>

                    {formik.touched.listFundingInfo?.[index]?.amountA && (formik.errors.listFundingInfo as any)?.[index]?.amountA && (
                      <div className="text-danger fs-12">{((formik.errors.listFundingInfo as any)[index] as any).amountA}</div>
                    )}
                  </div>
                </Col>
                <Col sm={12} md={6}>
                  <div className="mb-4">
                    <Label className="text-primary fs-13">{t("Amount B")}</Label>
                    <div className="position-relative">
                      <Input
                        className="no-icon-invalid"
                        type="text"
                        name={`listFundingInfo[${index}].amountB`}
                        value={funding.amountB}
                        placeholder="0"
                        onChange={(e) => formik.setFieldValue(`listFundingInfo[${index}].amountB`, e.target.value.replace(/[^0-9.]/g, ""))}
                        onBlur={formik.handleBlur}
                        invalid={!!(formik.touched.listFundingInfo?.[index]?.amountB && (formik.errors.listFundingInfo as any)?.[index]?.amountB)}
                      />
                      <span className="text-muted position-absolute" style={{ top: '9px', right: '9px' }}>{(formik.values.tokenInfo.tokenB as any)?.data?.symbol || ''}</span>
                    </div>
                    {formik.touched.listFundingInfo?.[index]?.amountB && (formik.errors.listFundingInfo as any)?.[index]?.amountB && (
                      <div className="text-danger fs-12">{((formik.errors.listFundingInfo as any)[index] as any).amountB}</div>
                    )}
                  </div>
                </Col>
                <Col sm={12} md={12}>
                  <div className="mb-4">
                    <Label className="text-primary fs-13">{t("Amount Native")}</Label>
                    <div className="position-relative">
                      <Input
                        className="no-icon-invalid"
                        type="text"
                        name={`listFundingInfo[${index}].amountNative`}
                        value={funding.amountNative}
                        placeholder="0"
                        onChange={(e) => formik.setFieldValue(`listFundingInfo[${index}].amountNative`, e.target.value.replace(/[^0-9.]/g, ""))}
                        onBlur={formik.handleBlur}
                        invalid={!!(formik.touched.listFundingInfo?.[index]?.amountNative && (formik.errors.listFundingInfo as any)?.[index]?.amountNative)}
                      />
                      <span className="text-muted position-absolute" style={{ top: '9px', right: '9px' }}>SOL</span>
                    </div>
                    {formik.touched.listFundingInfo?.[index]?.amountNative && (formik.errors.listFundingInfo as any)?.[index]?.amountNative && (
                      <div className="text-danger fs-12">{((formik.errors.listFundingInfo as any)[index] as any).amountNative}</div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          ))}
        </div>

        {/* Buttons */}
        <Row>
          <Col sm={12} className="mb-2 mt-3">
            <div className="d-flex gap-3 justify-content-end align-items-center">
              <button
                className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-items-center bg-[#878a99] hover:bg-[#737582]"
                type="button"
                onClick={onCloseClick}
                disabled={isLoading}
                style={{ width: "105px" }}
              >
                <span className="ms-1">{t("Button Close")}</span>
              </button>
              <button
                className="btn btn-primary fs-14 px-1 d-flex justify-content-center align-items-center bg-[#009ef7] hover:bg-[#0086d2]"
                type="submit"
                disabled={isLoading || (formik.values.status === 'CLOSED')}
                style={{ width: "165px" }}
              >
                {isLoading && <Spinner size="sm" className="me-2" />}
                <span>{idCampaign ? t("Update Campaign") : t("Create Campaign")}</span>
              </button>
            </div>
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default CampaignConfiguration;